import { render, staticRenderFns } from "./vpd-go-back.vue?vue&type=template&id=3d1c866e&scoped=true&"
import script from "./vpd-go-back.vue?vue&type=script&lang=js&"
export * from "./vpd-go-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c866e",
  null
  
)

export default component.exports